import type { VariableADTvalue } from '@lighthouse/core'
import { useCurrentEditor } from '@tiptap/react'
import type { FC } from 'react'
import React, { useCallback } from 'react'

import type { VariableSelectDropDownProps } from '../../'
import { VariablePicker } from '../../VariablePicker'

interface Props
    extends Partial<
        Pick<
            VariableSelectDropDownProps,
            | 'pageOptions'
            | 'inputOption'
            | 'filterOption'
            | 'viewOptions'
            | 'upstreamOptions'
            | 'datasourceOption'
            | 'userOption'
            | 'dateOption'
        >
    > {}

export const VariableMenu: FC<Props> = ({
    inputOption,
    filterOption,
    viewOptions,
    pageOptions,
    upstreamOptions,
    datasourceOption,
    userOption,
    dateOption
}) => {
    const { editor } = useCurrentEditor()

    const onSelect = useCallback(
        (value: VariableADTvalue) => {
            editor?.chain().focus().setVariable(value).run()
        },
        [editor]
    )

    return (
        <VariablePicker
            onSelect={onSelect}
            inputOption={inputOption}
            filterOption={filterOption}
            viewOptions={viewOptions}
            pageOptions={pageOptions}
            upstreamOptions={upstreamOptions}
            datasourceOption={datasourceOption}
            userOption={userOption}
            dateOption={dateOption}
            enableFormula
        />
    )
}
